import { DOMAIN } from './Scripts.constants';
import get from 'lodash/get';

export const getStore = state => get(state, DOMAIN) || [];
